/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Fill_BelowInputs */

const en_us2_workout_logging_fill_below = /** @type {(inputs: Workout_Logging_Fill_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill below`)
};

const pt_br2_workout_logging_fill_below = /** @type {(inputs: Workout_Logging_Fill_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preencher abaixo`)
};

const es_419_workout_logging_fill_below = /** @type {(inputs: Workout_Logging_Fill_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llenar abajo`)
};

const pt_pt2_workout_logging_fill_below = /** @type {(inputs: Workout_Logging_Fill_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preencher abaixo`)
};

const fr_fr2_workout_logging_fill_below = /** @type {(inputs: Workout_Logging_Fill_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplir en dessous`)
};

const de_de2_workout_logging_fill_below = /** @type {(inputs: Workout_Logging_Fill_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach unten füllen`)
};

const it_it2_workout_logging_fill_below = /** @type {(inputs: Workout_Logging_Fill_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compila sotto`)
};

/**
* | output |
* | --- |
* | "Fill below" |
*
* @param {Workout_Logging_Fill_BelowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_fill_below = /** @type {((inputs?: Workout_Logging_Fill_BelowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Fill_BelowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_fill_below(inputs)
	if (locale === "es-419") return es_419_workout_logging_fill_below(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_fill_below(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_fill_below(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_fill_below(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_fill_below(inputs)
	return en_us2_workout_logging_fill_below(inputs)
});
export { workout_logging_fill_below as "workout-logging.fill_below" }